<template lang="pug">
  .component-create-entity-button
    .row
      .columns
        label Name
          input(type="text", v-model="localValue.name")
        label Description
          input(type="text", v-model="localValue.description")
      .columns
        .row
          .columns
            div
              label Number required
              input(type="checkbox", v-model="localValue.has_number")
            div
              label Emission date required
              input(type="checkbox", v-model="localValue.has_emission")
            div
              label Expiry date required
              input(type="checkbox", v-model="localValue.has_expiry")
          .columns
            label Issuer required
            input(type="checkbox", v-model="localValue.has_issuer")
            div
              label Country required
              input(type="checkbox", v-model="localValue.has_country")
        label Attachment views
          .input-group(v-if="typeof localValue.attachment_views !== 'string'", v-for="(attachments, index) in localValue.attachment_views")
            input.input-group-field(type='text', v-model="localValue.attachment_views[index]")
            .input-group-button
              button.button.warning(@click="localValue.attachment_views.splice(index, 1)") -
        button.button.small(@click="localValue.attachment_views.push([])") Add view
</template>
<script type="text/babel">

import BaseForm from "./BaseForm.vue";

export default {
  name: 'DocumentTypeForm',
  extends: BaseForm,
  components: {},
  data() {
    return {}
  },
  created() {
  },
  methods: {},
  props: ['value']
}
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// DocumentTypeForm.vue?e2abaea8